document.addEventListener('DOMContentLoaded', () => {

  const viewport = document.querySelector('.cb-shop-carousel__viewport');
  const track = document.querySelector('.cb-shop-carousel__track');

  if (!viewport || !track) return;

  // Duplicate cards once for seamless looping
  track.innerHTML += track.innerHTML;

  let cards = [...track.children];

  let position = 0;
  let speed = 0.75;

  let isDragging = false;
  let startX = 0;
  let previousTranslate = 0;

  function animate() {

    if (!isDragging) {

      position -= speed;

      const halfWidth = track.scrollWidth / 2;

      if (Math.abs(position) >= halfWidth) {
        position = 0;
      }

      track.style.transform =
        `translate3d(${position}px,0,0)`;

    }

    requestAnimationFrame(animate);

  }

  animate();

  viewport.addEventListener('mouseenter', () => {
    speed = 0;
  });

  viewport.addEventListener('mouseleave', () => {
    speed = 0.75;
  });

  viewport.addEventListener('mousedown', dragStart);
  viewport.addEventListener('touchstart', dragStart,{passive:true});

  window.addEventListener('mousemove', dragMove);
  window.addEventListener('touchmove', dragMove,{passive:true});

  window.addEventListener('mouseup', dragEnd);
  window.addEventListener('touchend', dragEnd);

  function getX(e){

    return e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].pageX;

  }

  function dragStart(e){

    isDragging = true;

    startX = getX(e);

    previousTranslate = position;

    viewport.style.cursor='grabbing';

  }

  function dragMove(e){

    if(!isDragging) return;

    const currentX = getX(e);

    const diff = currentX-startX;

    position = previousTranslate+diff;

    track.style.transform =
      `translate3d(${position}px,0,0)`;

  }

  function dragEnd(){

    isDragging=false;

    viewport.style.cursor='grab';

  }

});